import { useMemo } from "react";
import { Crown } from "lucide-react";
import { money, calcCommission, effectiveRate } from "../lib/finance";

function computeCustomerLtv(customer, policies, branches, settings) {
  const rows = policies.filter((p) => p.customer === customer.name && p.status !== "iptal");
  const ltv = rows.reduce((s, p) => {
    const c = calcCommission(p.premium, effectiveRate(p, branches), settings.netDivisor, settings.personalShare, p.netPremium, null);
    return s + c.personal;
  }, 0);
  return { ltv, policyCount: rows.length };
}

export { computeCustomerLtv };

export function VipCustomersCard({ policies, customers, branches, settings, onOpenCustomer }) {
  const top = useMemo(() => {
    return customers
      .map((c) => ({ ...c, ...computeCustomerLtv(c, policies, branches, settings) }))
      .filter((c) => c.ltv > 0)
      .sort((a, b) => b.ltv - a.ltv)
      .slice(0, 5);
  }, [customers, policies, branches, settings]);
  if (top.length === 0) return null;
  const maxLtv = top[0].ltv || 1;
  return (
    <section className="panel vip-card" data-testid="vip-customers-card">
      <div className="panel-head">
        <div>
          <h2 style={{ display: "flex", alignItems: "center", gap: 8 }}><Crown size={18} color="#eab308" /> VIP Müşteriler</h2>
          <p>Size en çok kazandıran 5 müşteri · toplam kişisel hak ediş</p>
        </div>
      </div>
      <div className="vip-list">
        {top.map((c, idx) => (
          <button key={c.id} type="button" className="vip-row" data-testid={`vip-row-${c.id}`} onClick={() => onOpenCustomer(c)}>
            <div className="vip-rank">#{idx + 1}</div>
            <div className="vip-name">
              <strong>{c.name}</strong>
              <span className="muted small">{c.policyCount} poliçe · {c.phone || "—"}</span>
            </div>
            <div className="vip-ltv">
              <strong>{money(c.ltv)}</strong>
              <div className="vip-bar"><div style={{ width: `${(c.ltv / maxLtv) * 100}%` }} /></div>
            </div>
            {idx === 0 && <Crown size={16} color="#eab308" />}
          </button>
        ))}
      </div>
    </section>
  );
}
